module.exports = __webpack_public_path__ + "static/media/pjhegarty.df2296a1.png";